/**
 * Parse a full name into first and last name components.
 * Returns empty strings if parts are missing (matches IPrivateUserData types).
 */
export function parseFullName(fullName: string): {
  firstName: string;
  lastName: string;
} {
  const nameParts = fullName.trim().split(/\s+/);
  const firstName = nameParts[0] || "";
  const lastName = nameParts.length > 1 ? nameParts.slice(1).join(" ") : "";
  return { firstName, lastName };
}
